import { AxiosRequestConfig } from "axios";
import { AuthInput } from "@movinglayers/signing";
import apiClient from "./api.ts";

export const authenticate = async (data: AuthInput, config: AxiosRequestConfig = {}) => {
    return apiClient.post("/auth/local?populate=*", {
        identifier: data.identifier,
        password: data.password
    }, config);
};

